/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Typography } from "@mui/material";
import BreadCrum from "../../../components/layout/BreadCrumb";
import NewCustomerForm from "./NewCustomerForm";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useCrudForm } from "../../../api/useCrudForm";
import { endpoints } from "../../../api/endpoints";

const NewCustomerRegistration = () => {

    const [selectedCustomer, setSelectedCustomer] = useState<any>()
    const [selectedcustomerLockers, setSelectedCustomerLockers] = useState<any>()

    const location = useLocation()
    const router = useNavigate()
    const { id } = useParams()
    const { get } = useCrudForm()
    const isAttorney = location.search.includes('?attorney') || selectedCustomer?.accountType === 2 || selectedcustomerLockers?.accountType === 2
    const isJoint = location.search.includes('?joint') || selectedCustomer?.accountType === 1 || selectedcustomerLockers?.accountType === 1

    const searchParams = new URLSearchParams(location.search);

    const customerId = searchParams.get('customerId');
    const isMainTable = searchParams.get('isMainTable');

    const fetchData = async (cID?: any, lockersList?: any) => await get({
        endpoints: endpoints.customer.get + `/${cID ?? id}?isMainTable=${isMainTable != null ? isMainTable : false}`,
        onSuccess: (data: any) => {
            if (cID) {
                setSelectedCustomerLockers({ ...lockersList, applicationNumber: data?.data?.customerInfo?.applicationNumber, accountNumber: data.data?.customerInfo?.accountNumber })
            } else {
                isMainTable === 'true' ? setSelectedCustomer({ ...data.data?.customerInfo, passcode: '' }) : setSelectedCustomer({ ...data.data?.tempcustomerInfo, passcode: '' })
            }
        },
        onError: (error: any) => {
            router({ pathname: `/customers`, })
            console.log(error)
        }
    })


    const fetchCustomerData = async () => await get({
        endpoints: endpoints.customerLockers.api + `/${customerId}`,
        onSuccess: async (data: any) => {

            const accountType = () => {
                if (isJoint) {
                    return 1
                } else if (isAttorney) {
                    return 2
                }
            }

            const lockersList = { customerLockers: data.data, accountType: accountType(), customerId: Number(customerId) }
            fetchData(customerId, lockersList)

        },
        onError: (error: any) => {
            console.log(error)
        }
    })

    useEffect(() => {
        if (id && id !== '') {
            fetchData()
        }

    }, [id])

    useEffect(() => {
        if (customerId && customerId !== '') {
            fetchCustomerData()
        }

    }, [customerId])


    return (
        <Box>
            <TopBreadcrumbs />
            <Typography variant="h5" component="h2" my={3} fontWeight={600}> {id ? 'Edit' : 'Add New'} {isAttorney ? `Attorney` : "Customer"}  {id ? '' : 'Registration'}</Typography>
            <Box sx={{ padding: "24px 12px", background: "white", borderRadius: "5px" }}>
                <NewCustomerForm isJoint={isJoint} isAttorney={isAttorney} selectedCustomer={selectedCustomer ?? selectedcustomerLockers} fetchData={fetchData} />
            </Box>
        </Box>
    );
}

const TopBreadcrumbs = () => {
    const location = [{ name: "Customers", to: "/customers" }, { name: "Registration" }]
    return (
        <BreadCrum location={location} />
    );
}

export default NewCustomerRegistration;
